export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: { 'content-type': 'application/json', ...(init?.headers ?? {}) },
  });
  const body = (await response.json().catch(() => ({}))) as Record<string, unknown>;
  if (!response.ok) {
    throw new ApiError(
      response.status,
      typeof body.error === 'string' ? body.error : 'unknown',
      typeof body.message === 'string' ? body.message : 'Request failed',
    );
  }
  return body as T;
}

export interface CreatedRoom {
  roomId: string;
  playerId: string;
  resumeToken: string;
  inviteUrl: string;
}

export interface RoomPreview {
  status: 'lobby' | 'playing' | 'finished';
  seatCount: number;
  maxPlayers: number;
  joinable: boolean;
}

export function createRoom(name: string, seed?: string): Promise<CreatedRoom> {
  return request('/api/rooms', { method: 'POST', body: JSON.stringify({ name, seed }) });
}

export function previewRoom(roomId: string): Promise<RoomPreview> {
  return request(`/api/rooms/${roomId}`);
}

export function joinRoom(
  roomId: string,
  name: string,
): Promise<{ playerId: string; resumeToken: string }> {
  return request(`/api/rooms/${roomId}/join`, {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}
